import { createFileRoute } from '@tanstack/react-router'

/**
 * A lounge with no nook open.
 *
 * Not an error and not a redirect: which room you were last in is a per-device
 * question this milestone does not answer, and picking one for you would be a
 * guess you have to undo.
 */
export const Route = createFileRoute('/_app/l/$loungeSlug/')({
  component: NoNookOpen,
})

function NoNookOpen() {
  return (
    <div className="lounge-empty">
      <p className="pane-title">Pick a nook</p>
      <p className="muted">
        Every nook is a room: its own history, and — from the next milestone — its own voices.
        Choose one on the left to start reading.
      </p>
    </div>
  )
}
